"use client"

import { ImageX } from "@untitledui/icons"

import { Badge } from "@/components/ui/badge"
import { Link } from "@/components/ui/link"
import { TagBadgeGroup } from "@/components/ui/tag-badge"
import type { TrackSummary } from "@/types"

interface RelatedTrackCardProps {
  track: TrackSummary
}

/**
 * RelatedTrackCard component.
 * @param track - The track to render.
 * @returns The RelatedTrackCard component.
 */
export default function RelatedTrackCard({ track }: RelatedTrackCardProps) {
  const href = `/playlists/${track.playlist_id}/tracks/${track.id}`

  return (
    <article className="border-secondary bg-primary flex gap-4 rounded-xl border p-4">
      <div className="bg-secondary_subtle relative size-16 shrink-0 overflow-hidden rounded-lg md:size-20">
        {track.post.thumbnail_url ? (
          <img
            src={track.post.thumbnail_url}
            alt={track.post.title}
            className="size-full object-cover"
          />
        ) : (
          <div className="flex size-full items-center justify-center">
            <ImageX className="text-quaternary size-8" />
          </div>
        )}
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <Link
          href={href}
          className="text-primary text-md truncate font-semibold"
        >
          {track.post.title}
        </Link>

        {track.post.creator && (
          <p className="text-tertiary truncate text-sm">{track.post.creator}</p>
        )}

        {track.post.published === false && (
          <div className="flex flex-wrap items-center gap-2">
            <Badge size="sm" color="gray" type="modern">
              Private
            </Badge>
          </div>
        )}

        <TagBadgeGroup variant="row" tags={track.tags} />
      </div>
    </article>
  )
}
